/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as inventorizationSlice from './inventorizationSlice';

export default function* watchInventorizationSaga() {
 yield takeLatest(inventorizationSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(inventorizationSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(
  inventorizationSlice.createItemStart.type,
  commonSagas.createItem,
 );
 yield takeLatest(
  inventorizationSlice.updateItemStart.type,
  commonSagas.updateItem,
 );
 yield takeLatest(
  inventorizationSlice.deleteItemsStart.type,
  commonSagas.deleteItems,
 );
 yield takeLatest(
  inventorizationSlice.deleteItemStart.type,
  commonSagas.deleteItem,
 );
 yield takeLatest(
  inventorizationSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  inventorizationSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  inventorizationSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  inventorizationSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  inventorizationSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
